import { APP_NAME, LOGO_ICON, WEBSITE_URL } from "@calcom/lib/constants";
import { useLocale } from "@calcom/lib/hooks/useLocale";
import classNames from "@calcom/ui/classNames";

/**
 * Branding footer for public event booking pages.
 *
 * Deliberately points at WEBSITE_URL (the Jadwaly homepage) and the default logo rather than
 * the organizer's own domain/branding — this is a link back to the platform, not to the org.
 */
export const EventFooter = ({ className }: { className?: string }) => {
  const { t } = useLocale();

  return (
    <footer className={classNames("flex w-full items-center justify-center", className)}>
      <a
        href={WEBSITE_URL}
        target="_blank"
        rel="noreferrer noopener"
        data-testid="event-footer-link"
        className="inline-flex items-center gap-x-1.5 rounded-md px-2 py-1 text-subtle text-xs leading-none transition-colors hover:text-jadwaly-brand focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-jadwaly-brand sm:text-sm">
        <img src={LOGO_ICON} alt="" aria-hidden="true" className="size-4 shrink-0 sm:size-[18px]" />
        <span className="first-letter:uppercase">
          {t("powered_by")} {APP_NAME}
        </span>
      </a>
    </footer>
  );
};
